export interface NutritionItemProps {
  title: string
  item: string
  unit: string
}

export const useNutritionItem = (props: NutritionItemProps) => {
  return {
    ...props,
  }
}
